import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import Input, { InputProps } from '../Input'
import 'react-datepicker/dist/react-datepicker.css'
import { Calendar } from 'lucide-react'
import Icon from '../Icon'
import { useLocale } from 'next-intl'

type DatepickerProps = Omit<ReactDatePickerProps, 'value' | 'showPopperArrow' | 'dateFormat'> &
    Omit<InputProps, 'onChange' | 'value'> & {
        value?: ReactDatePickerProps['selected']
        'data-testid'?: string
    }

const Datepicker = ({ onChange, 'data-testid': dataTestId, value, ...props }: DatepickerProps) => {
    const { label, message, state, placeholder, ...rest } = props
    const locale = useLocale()

    const resolveDateFormat = () => {
        if (locale === 'en') {
            return 'yyyy-MM-dd'
        }

        return 'dd/MM/yyyy'
    }

    return (
        <div className="custom-datepicker-wrapper">
            <ReactDatePicker
                selected={value}
                onChange={onChange}
                placeholderText={placeholder}
                customInput={
                    <Input
                        {...{ label, message, state }}
                        data-testid={dataTestId}
                        rightIcon={<Icon icon={Calendar} />}
                    />
                }
                dateFormat={resolveDateFormat()}
                showPopperArrow={false}
                wrapperClassName="w-full"
                {...rest}
            />
        </div>
    )
}

export default Datepicker
